import ApiServer from '@/utils/api/ApiServer.js'
import { TractContent } from '@/model/Tract.js'

const allocationBasePath = (tractId, tractContentId) =>
  `tracts/${tractId}/tractcontents/${tractContentId}/allocations`

export default {
  async fetchTractContents (context, { tractId, isVolumeBased = false }) {
    const url = ApiServer.urlFor(`tracts/${tractId}/tractcontents`, {
      params: {
        isVolumeBased
      }
    })
    const response = await ApiServer.get(url)
    const tractContents = response.data.map(tc => new TractContent(tc))
    context.commit('setTractContents', tractContents)
    return tractContents
  },
  async deleteTractContent (context, ids) {
    const path = `tracts/${ids.tractId}/tractContents/${ids.tractContentId}`
    const response = await ApiServer.delete(path)
    context.commit('removeTractContent', ids.tractContentId)
    return response.data
  },
  async createTractContent (context, tractContent) {
    const parsedTractContent = {
      productId: parseInt(tractContent.productId),
      speciesId: parseInt(tractContent.speciesId),
      tractId: parseInt(tractContent.tractId),
      expected: parseFloat(tractContent.expected),
      expectedMBF: parseFloat(tractContent.expectedMBF),
      adjustment: parseFloat(tractContent.adjustment),
      adjustmentMBF: parseFloat(tractContent.adjustmentMBF),
      pricePerUnit: parseFloat(tractContent.pricePerUnit),
      pricePerMBF: parseFloat(tractContent.pricePerMBF),
      obligationRate: parseFloat(tractContent.obligationRate)
    }

    const path = `tracts/${tractContent.tractId}/tractcontents`

    const response = await ApiServer.post(path, parsedTractContent)
    context.commit('addTractContent', response.data)
    return response
  },
  async updateTractContent (context, tractContent) {
    const path = `tracts/${tractContent.tractId}/tractContents/${tractContent.tractContentId}`
    const response = await ApiServer.put(path, tractContent)
    return response
  },

  // Tract Content Allocation actions
  async fetchTractContentAllocations (_, { tractId, tractContentId }) {
    const path = allocationBasePath(tractId, tractContentId)
    const { data: allocations } = await ApiServer.get(path)
    return allocations
  },
  async createTractContentAllocation (_, { tractId, tractContentId, destinationAccountId, expected }) {
    const path = allocationBasePath(tractId, tractContentId)
    const requestObj = {
      tractContentId: parseInt(tractContentId),
      destinationAccountId: parseInt(destinationAccountId),
      expected: parseInt(expected)
    }
    const { data } = await ApiServer.post(path, requestObj)
    return data
  },
  async updateTractContentAllocation (_, { tractId, tractContentId, tractContentAllocationId, destinationAccountId, expected }) {
    const path = `${allocationBasePath(tractId, tractContentId)}/${tractContentAllocationId}`
    const requestObj = {
      tractContentId: parseInt(tractContentId),
      tractContentAllocationId: parseInt(tractContentAllocationId),
      destinationAccountId: parseInt(destinationAccountId),
      expected: parseFloat(expected)
    }
    const { data } = await ApiServer.put(path, requestObj)
    return data
  },
  async deleteTractContentAllocation (_, { tractId, tractContentId, tractContentAllocationId }) {
    const path = `${allocationBasePath(tractId, tractContentId)}/${tractContentAllocationId}`
    await ApiServer.delete(path)
  },
  async fetchTractContentAllocationSummaryByDestination (_, destinationAccountId) {
    const path = `accounts/${destinationAccountId}/tractcontentallocations`
    const { data } = await ApiServer.get(path)
    return data
  },
  async fetchTractContentAllocationSummary (_) {
    const path = 'accounts/tractcontentallocations'
    const { data } = await ApiServer.get(path)
    return data
  }
}
